<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Do Used books & eBooks come with supplemental materials such as Access Codes,
				CD-ROMs, or DVDs?</h1>
			<p>
				Used books and eBooks are not guaranteed to come with unused supplements/consumables. If you know the supplement is required, please order a new
				copy.
			</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "SupplementalMaterials",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>